import React from 'react';

const ConfirmModal = ({ show, onConfirm, onCancel, message }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <p>{message}</p>
        <div className="modal-buttons">
          <button className="btn" onClick={onConfirm}>
            はい
          </button>
          <button className="btn" onClick={onCancel}>
            いいえ
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;